<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <span class="filter-title">Year</span>
          <el-input
            v-model="year"
            clearable
            style="width:100px;margin-right:8px;"
          />
        </div>

        <div class="filter-item">
          <span class="filter-title">Month</span>
          <el-input
            v-model="month"
            clearable
            style="width:100px;margin-right:8px;"
          />
        </div>

        <el-button
          type="primary"
          size="mini"
          @click="handleDownload"
        >
          Download
        </el-button>
      </div>
    </template>
  </sticky-header-layout>
</template>

<script>
import { downloadMonthlyGMV } from '../../api/reports'

import fileDownload from '../../utils/file-download'

export default {
  name: 'MonthlyGMVReport',
  data() {
    return {
      isLoading: false,
      year: '',
      month: '',
    }
  },
  created() {
    const date = new Date()
    this.year = date.getFullYear()
    this.month = date.getMonth() + 1
  },
  methods: {
    handleDownload() {
      this.downloadReport(this.year, this.month)
    },
    async downloadReport(year, month) {
      this.isLoading = true

      try {
        const response = await downloadMonthlyGMV(year, month)
        const { data } = response
        fileDownload(data, `monthly_gmv_report_${year}_${month.toString().padStart(2, '0')}.csv`)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
</style>
